<template>
    <div :class="classes" v-show="show" @click="overlayClick"></div>
</template>

<script>
    export default {
        data() {
            return {
                show: false,
                closeOnClick: true,
                transparent: true
            }
        },

        props: {
            navbar: {
                default: false,
            }
        },

        mounted() {
            bus.$on('show-overlay', (closeOnClick=true, transparent=true) => {
                this.show = true;
                this.closeOnClick = closeOnClick;
                this.transparent = transparent;
            });

            bus.$on('hide-overlay', () => {
                this.show = false;
            });
        },

        computed: {
            classes() {
                return {
                    'Overlay': true,
                    'Overlay--transparent': this.transparent,
                }
            }
        },

        methods: {
            /**
             * Hide the overlay and let the other components know
             */
            hideOverlay() {
                this.show = false;
                this.closeOnClick = true;
                this.transparent = true;

                bus.$emit('overlay-clicked');
            },

            /**
             * The overlay has been clicked
             */
            overlayClick() {
                if (this.closeOnClick) {
                    this.hideOverlay();
                }
            }
        }
    }
</script>